import Link from '../Link'
import { styled } from '../../utils/styled'
import Grid from '../Grid'
import { type Theme } from '../theme'
import { type CSSObject } from '@mui/material/styles'

export const StyledCardContainer = styled(Grid)(() => ({
  width: '352px'
}))

export const getClickableStyles = (theme: Theme): CSSObject => {
  return {
    '&:hover': {
      cursor: 'pointer',
      boxShadow: theme.elevation.largeDepth
    }
  }
}

export const StyledCard = styled('div')<{
  elevation: 'flat' | 'mediumDepth' | 'largeDepth'
  $isClickable: boolean
}>(
  ({ elevation, $isClickable: isClickable, theme }): CSSObject => ({
    border: `1px solid ${theme.tokens.border.main.tonal}`,
    borderRadius: theme.borderRadius.xxLarge,
    transition: 'box-shadow 100ms ease-in-out',
    boxShadow: theme.elevation[elevation],
    backgroundColor: theme.tokens.background.main.default,
    color: theme.tokens.foreground.main.primary,
    padding: '19px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '16px 0',
    ...(isClickable && getClickableStyles(theme))
  })
)

export const StyledAvatarContainer = styled(Grid)(
  ({ theme }): CSSObject => ({
    display: 'flex',
    alignItems: 'center',
    div: {
      ':first-of-type': {
        marginRight: '16px'
      }
    }
  })
)

export const StyledLink = styled(Link)(
  (): CSSObject => ({
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none'
    },
    '&:link': {
      color: 'inherit'
    }
  })
)
